import React, { useMemo, useState, useEffect } from 'react';
import { Card, Col, Row, Button } from 'react-bootstrap';
import { useParams, NavLink } from "react-router-dom";
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import Alert from 'react-bootstrap/Alert';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import { postMasterType, postMasterData, postMasterDataSave, deleteMasterData, postMasterDataChangeOrder, postMasterDataStatus } from '../../apiservices/ApiServices';
import { FaTimesCircle, FaRegCheckCircle } from "react-icons/fa";

const SubMaster = () => {
    const [show, setShow] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [masterData, setMasterData] = useState([]);
    const [data, setData] = useState([]);
    const { typeId } = useParams();
    const [editRowId, setEditRowId] = useState(null);
    const [editValue, setEditValue] = useState("");

    const postMasterTypes = async (postData) => {
        try {
            const res = await postMasterType(postData);
            setMasterData(res.data.data.records);
        } catch (error) {
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postMasterDatas = async (postData) => {
        setLoading(true);
        try {
            const res = await postMasterData(postData);
            setData(res.data.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdateMasterData = async () => {
        let postData = {
            search: "",
            filters: {
                name: ""
            },
            page: 1,
            length: 100,
            master_type_id: typeId
        }
        try {
            const res = await postMasterData(postData);
            setData(res.data.data);

        } catch (error) {
            console.log(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        let postData = {
            length: 500,
        }
        postMasterTypes(postData);
    }, []);

    useEffect(() => {
        let postData = {
            search: "",
            filters: {
                name: ""
            },
            page: 1,
            length: 100,
            master_type_id: typeId
        }
        postMasterDatas(postData);
    }, [typeId]);

    const handleSave = async () => {
        setLoadings(true);
        const postData = {
            master_data_id: editRowId,
            display_order: editValue
        };
        try {
            const res = await postMasterDataChangeOrder(postData);
            toast.success(res.data.message);
            postUpdateMasterData();
            setLoadings(false);
            setEditRowId(null);
            setEditValue("");
        } catch (error) {
            console.log(error.response?.data?.message || "Error submitting data");
        }
    };

    const columns = useMemo(
        () => [
            {
                Header: "Display Order",
                accessor: "display_order",
                width: 170,
                Cell: ({ row, value }) => {
                    const isEditing = row.original.id === editRowId;

                    return isEditing ? (
                        <div className='dorderboxs'>
                            <input
                                type="text"
                                className="form-control"
                                value={editValue}
                                autoFocus
                                onChange={(e) => setEditValue(e.target.value)}
                                style={{ width: "80px" }}
                            />
                            <button type='button' className='btn btn-red' onClick={() => setEditRowId(null)}><FaTimesCircle /></button>
                            <button type='button' className='btn btn-primary' onClick={() => handleSave()}><FaRegCheckCircle /></button>
                        </div>
                    ) : (
                        <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                setEditRowId(row.original.id);
                                setEditValue(value);
                            }}
                        >
                            {value}
                        </span>
                    );
                }
            },
            {
                Header: "Name",
                accessor: "name",
                width: 400,
            },

            {
                Header: "is Active",
                accessor: "isactive",
                width: 99,
                disableSortBy: true,
            },
            {
                Header: "is Default",
                accessor: "isdefault",
                width: 99,
                disableSortBy: true,
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        [editRowId, editValue, setEditRowId, setEditValue, handleSave]
    );

    const actions = ['edit', 'delete']
    const subActions = []

    const emptyStatement = {
        eId: '',
        eName: '',
        eIsActive: '',
        eIsDefault: '',
        eDisplayOrder: '',

        subMasters: {
            id: '',
            name: '',
            isActive: '',
            isDefault: '',
            displayOrder: '',
        }
    };

    const [initialFormikValues, setInitialFormikValues] = useState({
        subMasters: [emptyStatement]
    });

    const add = () => {
        setFieldValue('subMasters', [...values.subMasters, { ...emptyStatement }]);
    };

    const remove = (index) => {
        const updated = values.subMasters.filter((_, i) => i !== index);
        setFieldValue('subMasters', updated);
    };

    const transformFormValuesToPostData = (values) => {
        return {
            master_type_id: typeId,
            master_data: values.subMasters.map((item) => ({
                name: item?.name,
                is_active: item.isActive,
                is_default: item.isDefault,
                display_order: item.displayOrder
            })),
        };
    };

    const formik = useFormik({
        initialValues: initialFormikValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);

            if (addModal) {
                const postData = transformFormValuesToPostData(values);
                try {
                    const res = await postMasterDataSave(postData);
                    toast.success(res.data.message);
                    postUpdateMasterData();
                    setAddModal(false);
                    setLoadings(false);
                    formik.resetForm();
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }

            if (editModal) {
                let postData = {
                    master_type_id: typeId,
                    master_data_id: values.eId,
                    master_data: [{
                        name: values.eName,
                        is_active: values.eIsActive,
                        is_default: values.eIsDefault,
                        display_order: values.eDisplayOrder,
                    }]
                }

                console.log('EpostData', postData)

                try {
                    const res = await postMasterDataSave(postData);
                    toast.success(res.data.message);
                    postUpdateMasterData();
                    setEditModal(false);
                    setLoadings(false);
                    formik.resetForm();
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const handleConfirm = () => {
        setAddModal(false);
        setEditModal(false);
        formik.resetForm();
    };

    const handleEdit = async (rowData) => {
        setFieldValue('eId', rowData?.id);
        setFieldValue('eName', rowData?.name);
        setFieldValue('eIsActive', rowData?.is_active);
        setFieldValue('eIsDefault', rowData?.is_default);
        setFieldValue('eDisplayOrder', rowData?.display_order);

        setEditModal(true);
    };

    const handleDelete = (rowData) => {
        setShow(true);
        setFieldValue('eId', rowData?.id);
        setFieldValue('eName', rowData?.name);
    };

    const handleDeleteCon = async () => {
        setLoadings(true);
        try {
            const res = await deleteMasterData(values.eId);
            toast.success(res.data.message);
            setLoadings(false);
            setShow(false);
            postUpdateMasterData();
            setFieldValue('eId', '');
            setFieldValue('eName', '');
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            setShow(false);
        }
    };

    const handleIsActive = async (rowData) => {
        setLoadings(true);
        let postData = {
            id: rowData?.id,
            action: 'status'
        }
        try {
            const res = await postMasterDataStatus(postData);
            toast.success(res.data.message);
            postUpdateMasterData();
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            setShow(false);
        }
    };

    const handleonIsDefault = async (rowData) => {
        setLoadings(true);
        let postData = {
            id: rowData?.id,
            action: "default"
        }
        try {
            const res = await postMasterDataStatus(postData);
            toast.success(res.data.message);
            postUpdateMasterData();
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            setShow(false);
        }
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />
            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles={data?.master_type?.name + 'Sub Sectors'} active={data?.master_type?.name + 'Sub Sectors'} items={['Home']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <div className='Navtablist'>
                                <ul>
                                    {masterData?.map((item) => (
                                        <li><NavLink to={"/master/subMaster/" + item.id}>{item.name}</NavLink></li>
                                    ))}
                                </ul>
                            </div>
                        </Col>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body className="example1-table">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>{data?.master_type?.name} Sub Master</h1>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='w-100 d-flex justify-content-end'>
                                                    <Button
                                                        variant="primary"
                                                        onClick={() => setAddModal(true)}
                                                    >
                                                        Add New
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Tables
                                        columns={columns}
                                        data={data?.records}
                                        actions={actions}
                                        subActions={subActions}
                                        onEdit={handleEdit}
                                        onDelete={handleDelete}
                                        onIsActive={handleIsActive}
                                        onIsDefault={handleonIsDefault}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modals
                show={addModal}
                handleClose={() => setAddModal(false)}
                title="Add New Sub Master"
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    {values.subMasters.map((subMst, index) => (
                        <div key={index} className="fieldsets mainFS">
                            <div className='fieldsetsboxs'>
                                <h6>Sub {data?.master_type?.name} {index + 1}</h6>
                                <div className="addreovebtns">
                                    <button type="button" className="btn add-btn" onClick={add}>+</button>
                                    {values.subMasters.length > 1 && (
                                        <button type="button" className="btn remove-btn" onClick={() => remove(index)}>-</button>
                                    )}
                                </div>
                            </div>
                            <div className='formsBox'>
                                <Row>
                                    <Col md={6}>
                                        <div className="form-group">
                                            <label className="form-label">Sub Name</label>
                                            <input type="text"
                                                name="name"
                                                className="form-control"
                                                autoComplete='off'
                                                value={subMst.name}
                                                onChange={(e) => setFieldValue(`subMasters[${index}].name`, e.target.value)}
                                            />
                                            {errors?.subMasters?.[index]?.name &&
                                                touched?.subMasters?.[index]?.name && (
                                                    <p className="errormsg">{errors.subMasters[index].name}</p>
                                                )}
                                        </div>
                                    </Col>
                                    <Col md={3}>
                                        <div className="form-group">
                                            <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                                <label className="form-label">Is Active</label>
                                                <div className="switchs" style={{ marginLeft: 10 }}>
                                                    <input
                                                        type="checkbox"
                                                        name='isActive'
                                                        className="form-control"
                                                        autoComplete='off'
                                                        checked={subMst.isActive === 1}
                                                        onChange={(e) => setFieldValue(`subMasters[${index}].isActive`, e.target.checked ? 1 : 0)}
                                                        onBlur={handleBlur}
                                                    />
                                                    <span className="slider round"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={3}>
                                        <div className="form-group">
                                            <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                                <label className="form-label">Is Default</label>
                                                <div className="switchs" style={{ marginLeft: 10 }}>
                                                    <input
                                                        type="checkbox"
                                                        name='isDefault'
                                                        className="form-control"
                                                        autoComplete='off'
                                                        checked={subMst.isDefault === 1}
                                                        //onChange={(e) => setFieldValue(`subMasters[${index}].isDefault`, e.target.checked ? 1 : 0)}
                                                        onChange={(e) => {
                                                            const updated = values.subMasters.map((item, i) => ({
                                                                ...item,
                                                                isDefault: i === index ? 1 : 0
                                                            }));
                                                            setFieldValue("subMasters", updated);
                                                        }}
                                                        onBlur={handleBlur}
                                                    />
                                                    <span className="slider round"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    ))}
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Save</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            <Modals
                show={editModal}
                handleClose={() => setEditModal(false)}
                title="Edit Sub Master"
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={5}>
                            <div className="form-group">
                                <label className="form-label">Name</label>
                                <input
                                    type='text'
                                    id="eName"
                                    name="eName"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.eName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.eName && touched.eName && (
                                    <p className="errormsg">{errors.eName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="form-group">
                                <label className="form-label">Display Order</label>
                                <input
                                    type='text'
                                    id="eDisplayOrder"
                                    name="eDisplayOrder"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.eDisplayOrder}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.eDisplayOrder && touched.eDisplayOrder && (
                                    <p className="errormsg">{errors.eDisplayOrder}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={2}>
                            <div className="form-group">
                                <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                    <label className="form-label">Is Active</label>
                                    <div className="switchs" style={{ marginLeft: 10 }}>
                                        <input
                                            type="checkbox"
                                            name='eIsActive'
                                            className="form-control"
                                            autoComplete='off'
                                            value={values.eIsActive}
                                            checked={values.eIsActive === 1}
                                            onChange={(e) => setFieldValue('eIsActive', e.target.checked ? 1 : 0)}
                                            onBlur={handleBlur}
                                        />
                                        <span className="slider round"></span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col md={2}>
                            <div className="form-group">
                                <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                    <label className="form-label">Is Default</label>
                                    <div className="switchs" style={{ marginLeft: 10 }}>
                                        <input
                                            type="checkbox"
                                            name='eIsDefault'
                                            className="form-control"
                                            autoComplete='off'
                                            value={values.eIsActive}
                                            checked={values.eIsDefault === 1}
                                            onChange={(e) => setFieldValue('eIsDefault', e.target.checked ? 1 : 0)}
                                            onBlur={handleBlur}
                                        />
                                        <span className="slider round"></span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Update</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to Delete <span>{values.eName}</span> Sub Master?</Alert.Heading>
                    <hr />
                    <div className='button-boxs grid'>
                        <div>
                            <button onClick={() => handleDeleteCon()} className='btn btn-primary'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}

            {isLoadings && <Loader />}
        </>
    )
}

export default SubMaster;